import React, { useContext, useEffect, useState } from 'react';
import { GridWrapper, GridRow, GridColumn, StepBar } from 'react-onei';
import { useLocation } from 'react-router-dom';

import UserContext from "../../context/UserContext";

function Stepbar() {
    let location = useLocation();
    const { isChallenge, wording, serviceConf } = useContext(UserContext);
    const { bypassContactStep } = serviceConf;
    const [current, setCurrent] = useState(-1);
    const { WLOST_010, WLOST_011, WLOST_012, WLOST_013 } = wording;
    let steps = [WLOST_010, WLOST_011, WLOST_012];
    const map = new Map([
        ['/choice', 0],
        ['/choice/default', 0],
        ['/otc', 0],
        ['/password', 1],
        ['/contact', 2],
    ]);

    if (isChallenge) {
        map.delete('/choice');
        map.delete('/choice/default');
        map.delete('/otc');
        map.set('/password', 0);
        map.set('/contact', 1);
        steps.shift();
    }
    if (bypassContactStep) {
        map.delete('/contact');
        steps.pop();
    }

    useEffect(() => {
        function detectStepperLocation() {
            if (map.has(location.pathname)) {
                setCurrent(map.get(location.pathname));
            } else {
                setCurrent(-1);
            }
        }
        detectStepperLocation();
    }, [location, map]);

    if (current !== -1) {
        return (
            <GridWrapper>
                <GridRow>
                    <GridColumn>
                        <div className="spacing-xs">
                            <StepBar
                                id="stepbar"
                                steps={steps}
                                selected={current}
                                finalStep={WLOST_013}
                            />
                        </div>
                    </GridColumn>
                </GridRow>
            </GridWrapper>
        );
    }
    return null;
}

export default Stepbar;